import HystModal from 'hystmodal';

export const initDeclineModal = () => {
    const declineModal = document.querySelector('[data-decline-modal]');
    if (!declineModal) return;

    const modal = new HystModal();
    modal.open('[data-decline-modal]');
};
